module.exports = __webpack_public_path__ + "static/media/Gilroy-Bold.b381c2ab.ttf";